
import React from 'react';
import { Button, Stack, Box, Typography } from '@mui/material';
import UploadFileIcon from '@mui/icons-material/UploadFile';

const FileUpload = ({
  onFileSelect,
  onPreview,
  onImport,
  onReset,
  accept,
  loadingPreview,
  loadingImport,
  selectedFile,
  previewDisabled,
  importDisabled,
}) => {
  const handleFileChange = (event) => {
    const file = event.target.files?.[0];
    if (onFileSelect) {
      onFileSelect(file || null);
    }
    event.target.value = '';
  };

  return (
    <Stack direction={{ xs: 'column', md: 'row' }} spacing={2} alignItems={{ xs: 'stretch', md: 'center' }}>
      <Button
        component="label"
        variant="outlined"
        startIcon={<UploadFileIcon />}
        disabled={loadingPreview || loadingImport}
      >
        Datei auswählen
        <input type="file" hidden accept={accept} onChange={handleFileChange} />
      </Button>
      <Box sx={{ flex: 1 }}>
        <Typography variant="body2" color="text.secondary">
          Ausgewählt
        </Typography>
        <Typography variant="body1">
          {selectedFile ? selectedFile.name : 'Keine Datei ausgewählt'}
        </Typography>
      </Box>
      <Button
        variant="outlined"
        onClick={onPreview}
        disabled={!selectedFile || loadingPreview || loadingImport || previewDisabled}
      >
        {loadingPreview ? 'Vorschau läuft...' : 'Vorschau laden'}
      </Button>
      <Button
        variant="contained"
        onClick={onImport}
        disabled={!selectedFile || loadingPreview || loadingImport || importDisabled}
      >
        {loadingImport ? 'Import läuft...' : 'Import starten'}
      </Button>
      <Button
        variant="text"
        onClick={onReset}
        disabled={loadingPreview || loadingImport}
      >
        Zurücksetzen
      </Button>
    </Stack>
  );
};

export default FileUpload;
